import { computed, toValue } from "vue";
import { useAsyncData } from "#app";
import { hash } from "ohash";
import {
  uploadFiles as sdkUploadFiles,
  importFile as sdkImportFile,
  readFile as sdkReadFile,
  readFiles as sdkReadFiles,
  updateFile as sdkUpdateFile,
  updateFiles as sdkUpdateFiles,
  deleteFile as sdkDeleteFile,
  deleteFiles as sdkDeleteFiles
} from "@directus/sdk";
import { useDirectusRest } from "#imports";
export function useDirectusFiles(config) {
  const client = useDirectusRest(config);
  async function uploadFiles(data, query) {
    return await client.request(sdkUploadFiles(data, query));
  }
  async function importFile(url, data, query) {
    return await client.request(sdkImportFile(url, data, query));
  }
  async function readFile(id, query) {
    return await client.request(sdkReadFile(id, query));
  }
  async function readAsyncFile(id, params) {
    const { key, query, ..._params } = params ?? {};
    const _key = computed(() => {
      return key ?? "D_" + hash(["readAsyncFile", toValue(id), toValue(query)]);
    });
    return await useAsyncData(_key.value, () => readFile(toValue(id), toValue(query)), _params);
  }
  async function readFiles(query) {
    return await client.request(sdkReadFiles(query));
  }
  async function readAsyncFiles(params) {
    const { key, query, ..._params } = params ?? {};
    const _key = computed(() => {
      return key ?? "D_" + hash(["readAsyncFiles", toValue(query)]);
    });
    return await useAsyncData(_key.value, () => readFiles(toValue(query)), _params);
  }
  async function updateFile(id, item, query) {
    return await client.request(sdkUpdateFile(id, item, query));
  }
  async function updateFiles(id, item, query) {
    return await client.request(sdkUpdateFiles(id, item, query));
  }
  async function deleteFile(id) {
    return await client.request(sdkDeleteFile(id));
  }
  async function deleteFiles(id) {
    return await client.request(sdkDeleteFiles(id));
  }
  return {
    client,
    uploadFiles,
    importFile,
    readFile,
    readAsyncFile,
    readFiles,
    readAsyncFiles,
    updateFile,
    updateFiles,
    deleteFile,
    deleteFiles
  };
}
